import { render, staticRenderFns } from "./School.vue?vue&type=template&id=2573fca4&scoped=true"
import script from "./School.vue?vue&type=script&lang=ts"
export * from "./School.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2573fca4",
  null
  
)

export default component.exports